import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler } from "chart.js";
import { Line } from "react-chartjs-2";
import ChartHeading from "./ChartHeading";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const Productivity = ({ productivityData }) => {
  const data = {
    labels: productivityData.label,
    datasets: [
      {
        label: 'Cost',
        data: productivityData.data,
        fill: true,
        borderDashOffset: 0.0,
        pointHoverBackgroundColor: "#CB998D",
        pointHoverBorderColor: "#CB998D",
        pointBackgroundColor: "#CB998D",
        pointBorderColor: "#CB998D",
        backgroundColor: "#CB998D",
        borderColor: "#C6C6C6",
        pointRadius: 4,
      },
    ],
  };

  const options = {
    //       },
    //     },
    //   ],
    // },
    //   },
    // },
    plugins: {
      legend: {
        display: false,
      },
    },
  };
  return (
    <>
      <div className="header">
        <ChartHeading heading="Productivity" />
      </div>
      <Line
        data={data}
        options={options}
        style={{ backgroundColor: "#FAFAFB", padding: "20px" }}
      />
    </>
  );
};

export default Productivity;
